import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-line bg-navy-900 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-40" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-41" data-mp="xu0k9p77at9f">
        <h2 id="closing-title" className="text-balance text-center text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-42" data-mp="xs7eec4ewd2h">
          Stop Guessing. <span className="text-fiber" data-id="element-43" data-mp="17sge3zxm4gmm">Start Understanding Telecommunications & Fiber Optic Networks.</span>
        </h2>

        <ul className="mx-auto mt-10 max-w-3xl divide-y divide-line overflow-hidden rounded-xl border border-line bg-navy-950" data-id="element-44" data-mp="1lia1sexdsuur">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-white" data-id="element-45" data-mp="1vhiuz5kfa5g2" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-fiber" aria-hidden="true" data-id="element-46" data-mp="2cajnj5vl3f30" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}